import React from 'react';
import PropTypes from 'prop-types';
import { Calendar } from 'components/core/Calendar';
import { format, parse, addDays } from 'date-fns';
import { formatDatePretty } from 'utils/dateUtils';

import './CalendarV2.scss';

export function CalendarV2({ input, closures, reservationWindow, moveInDate }) {
	let selectedDateObj = null;
	if (moveInDate) {
		try {
			selectedDateObj = parse(moveInDate, 'MM/dd/yyyy', new Date());

			if (!selectedDateObj || Number.isNaN(selectedDateObj.getTime())) {
				selectedDateObj = null;
			}
		} catch (error) {
			selectedDateObj = null;
		}
	}
	
	// Parse closure strings to Date objects
	const closureDates = closures
		.filter(closure => closure && closure.trim() !== '')
		.map(closure => {
			try {
				const parsedDate = parse(closure, 'yyyy-MM-dd', new Date());
				return !Number.isNaN(parsedDate.getTime()) ? parsedDate : null;
			} catch (e) {
				return null;
			}
		})
		.filter(Boolean);
	
	const reservationWindowDate = reservationWindow != null && !Number.isNaN(reservationWindow)
		? addDays(new Date(), reservationWindow)
		: new Date();

	return (
		<div className="calendar-container">
			<Calendar
				className="ss-calendar-v2"
				closures={closureDates}
				reservationWindow={reservationWindowDate}
				today={new Date()}
				selectedDate={selectedDateObj}
				onDateClick={(dateObj) => {
					const actualDate = dateObj.date || dateObj;
					const formattedDate =
						dateObj.string || format(actualDate, 'MM/dd/yyyy');
					input.onChange(formattedDate);
					input.onBlur(formattedDate);
				}}
			/>
			<div className="calendar-date-text-container">
				<p className="move-in-date-label sf-type">MOVE-IN DATE</p>
				<h3 className="calendar-asterisk sf-type">
					{moveInDate
						? formatDatePretty(moveInDate)
						: 'Select a day...'}
				</h3>
				<span className="calendar-date-text sf-type">
					If you&apos;re unsure of your move-in date, select an estimated
					date. This can be changed later.
				</span>
			</div>
		</div>
	);
}

CalendarV2.propTypes = {
	input: PropTypes.shape({
		value: PropTypes.string,
		onChange: PropTypes.func.isRequired,
		onBlur: PropTypes.func.isRequired,
	}).isRequired,
	meta: PropTypes.shape({
		touched: PropTypes.bool,
		error: PropTypes.string,
	}),
	closures: PropTypes.arrayOf(PropTypes.string),
	reservationWindow: PropTypes.number,
	moveInDate: PropTypes.string,
};

CalendarV2.defaultProps = {
	closures: [],
	meta: {},
	moveInDate: null,
	reservationWindow: 0,
};

export default CalendarV2;
